import AppEvents from './app-events';
import ds from './ds';

export default class Form {

    constructor(id, options = {}) {
        if (document.getElementById(id) == null) {
            console.warn(`Form '${id}' not found`);
            return;
        }   

        this.id = id;
        
        var defaults = {
            bindEvents: true,
            beforeSubmit: this.#beforeSubmit
        };

        this.options = defaults.merge(options);

        this.#bindEvents();
    }

    #beforeSubmit = () => Promise.resolve(true);

    #bindEvents() {
        if (this.options.bindEvents) {
            // Form-Submit als letzter Handler - wird ausgeführt nachdem alle Grids gespeichert wurden
            AppEvents.onFormSubmit(async () => {
                await this.submit();
            });

            this.form.addEventListener('submit', async e => {
                e.preventDefault();

                // Speichere zuerst alle Grids
                const gridsSuccess = await AppEvents.saveRecord();

                if (gridsSuccess) {
                    // Wenn Grids erfolgreich gespeichert, dann Form absenden
                    AppEvents.formSubmit();
                } else {
                    AppEvents.notifyError({ 
                        Title: 'Fehler beim Speichern', 
                        Message: 'Bitte korrigieren Sie die Fehler in den Grids, bevor Sie das Formular absenden.' 
                    });
                }
            });
        }
    }

    get form() {
        return document.getElementById(this.id);
    }

    submit = async () => {
        let form = this.form;

        if (!await this.options.beforeSubmit(form)) {
            return;
        }

        AppEvents.emit(Form.EVENTS.BEFORE_SUBMIT, form);

        if (form.matches(":not([novalidate]") && !Form.validate(form))
            return;
            
        form.submit();
    }

    reset = () => {
        let elements = this.form.elements;

        for (let i = 0; i < elements.length; i++) {
            let el = elements[i];

            switch (el.type.toLowerCase()) {

                case "text":
                case "password":
                case "textarea":
                case "hidden":
                case "number":
                case "search":

                    el.value = "";
                    break;

                case "radio":
                case "checkbox":
                    if (el.checked) {
                        el.checked = false;
                    }
                    break;

                case "select-one":
                case "select-multi":
                    el.selectedIndex = -1;
                    break;

                default:
                    break;
            }
        }
    }

    data = () => Form.data(this.form);
    formData = () => Form.formData(this.form);

    static data = form => form.serializeObject();
    static formData = form => new FormData(form);
    static validate = form => $(form).valid();

    static handleErrors = (form, errors) => {
        let $form = $(form);

        let validator = $form.validate();
        Object.keys(errors).forEach(key => {
            if (key === "") {
                $form.find(".validation-summary-valid")
                    .html(`<div class="alert alert-danger"><span>${errors[key]}</span></div>`);
            } else {
                let list = {};
                list[key] = errors[key];

                validator.showErrors(list);
            }
        });
    }

    static submitAjax = async (form, url = null) => {
        if (Form.validate(form)) {
            AppEvents.emit(Form.EVENTS.BEFORE_SUBMIT, form);
            
            let postUrl = url || form.action;

            try {
                const formData = form.serializeObject();

                let result = await ds.post(postUrl, formData);
                if (result) {
                    if (result.Errors && Object.entries(result.Errors).length) {
                        Form.handleErrors(form, result.Errors);
                        return false;
                    }
                }

                return result;
            }
            catch (xhr) {
                if (xhr) {

                    switch (xhr.status) {   
                        case 400:
                            Form.handleErrors(form, JSON.parse(xhr.responseText));
                            return false;
                        case 500:
                            Form.handleErrors(form, { "": "Operation failed" });
                            return false;
                    }
                }

                throw xhr;
            }
        }

        return false;
    }

    static EVENTS = {
        BEFORE_SUBMIT: 'form.beforeSubmit',
        AFTER_SUBMIT: 'form.afterSubmit'
    }
}